import * as Yup from 'yup';
// import * as moment from 'moment';
// import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues() {
    return {
        claimIssue: 'QUALITY',
        totalNumberQuantity: '',
        totalNumberQuality: '',
        comments: '',
        typeOfIssue0: false,
        typeOfIssue1: false,
        typeOfIssue2: false,
        typeOfIssue3: false,
    }
}
export function getRegisterSchema(conditionalState) {
    if (conditionalState === "QUALITY") {
        let schemaAttributes = {
            totalNumberQuality: Yup.string().trim().required(''),
            fileUpload: Yup.string().trim().required(''),//File upload is required.
        };
        return Yup.object().shape(schemaAttributes);
    } else if (conditionalState === "BOTH") {
        let schemaAttributes = {
            totalNumberQuality: Yup.string().trim().required(''),
            totalNumberQuantity: Yup.string().trim().required(''),
            fileUpload: Yup.string().trim().required(''),//File upload is required.
        };
        return Yup.object().shape(schemaAttributes);
    }
    else {
        let schemaAttributes = {
            totalNumberQuantity: Yup.string().trim().required(''),
        };
        return Yup.object().shape(schemaAttributes);
    }
}